import { Button, Checkbox, Modal, Radio, Steps } from 'antd';
import icons from '../../utils/icons';
import PlayerRegTermsDisplay from '../PlayerRegTermsDisplay';
import useIsMobile from 'hooks/useIsMobile';
import SteppedDrawer from '../SteppedDrawer';

// Step aliases for better readability
const STEPS = {
  ACCEPT_TERMS: 1,
  CHOOSE_PAYMENT: 2,
  DONE: 3,
};

const SeasonPlayerRegistrationModal = ({
  open,
  onCancel,
  onAccept,
  loading,
  modal,
  step,
  setStep,
  agree,
  setAgree,
  payOption,
  setPayOption,
  currentRecord,
  termsChecked,
  setTermsChecked,
}) => {
  const isMobile = useIsMobile();

  if (!currentRecord || !currentRecord.Season) return null;

  const season = currentRecord.Season;
  const enabledTerms = [
    season.usePlayerRegTerms && season.playerRegTerms,
    season.usePlayerRegTerms2 && season.playerRegTerms2,
    season.usePlayerRegTerms3 && season.playerRegTerms3,
  ].filter(Boolean);

  // Ensure termsChecked is always the right length
  const allChecked = enabledTerms.length === 0 || (termsChecked.length === enabledTerms.length && termsChecked.every(Boolean));

  // Reset termsChecked when modal opens or enabledTerms changes
  if (open && (termsChecked.length !== enabledTerms.length)) {
    setTermsChecked(Array(enabledTerms.length).fill(false));
  }

  const Contents = () => {
    return (
      <>
        {modal.needsPayment && !isMobile && (
          <div className="mb-6 px-0 pt-2">
            <Steps current={step - 1} size="small" className="mb-4">
              <Steps.Step title="Accept Terms" />
              <Steps.Step title="Choose Payment Method" />
              <Steps.Step title="Done" />
            </Steps>
          </div>
        )}
        <div className="mt-4">
          {modal.needsPayment ? (
            step === STEPS.ACCEPT_TERMS ? (
              <>
                <PlayerRegTermsDisplay
                  terms={enabledTerms}
                  checked={termsChecked}
                  onChange={(idx, checked) => {
                    setTermsChecked(prev => {
                      const arr = [...prev];
                      arr[idx] = checked;
                      return arr;
                    });
                  }}
                />
                <Button
                  type="primary"
                  className="mt-4"
                  onClick={() => setStep(STEPS.CHOOSE_PAYMENT)}
                  block
                  disabled={!allChecked}
                >
                  Continue
                </Button>
              </>
            ) : (
              <>
                <Checkbox
                  checked={agree}
                  onChange={e => setAgree(e.target.checked)}
                  className="mb-2"
                >
                  <span className={`flex ${isMobile ? 'flex-col' : 'gap-1'}`}>
                    <span>I agree with payment to HMS:</span>
                    <span>The price for registration is <b>{season.playerRegFee} Kč</b></span>
                  </span>
                </Checkbox>
                <div className="mt-4 mb-3 font-semibold">Select a payment method:</div>
                <Radio.Group
                  disabled={!agree}
                  value={payOption}
                  onChange={e => setPayOption(e.target.value)}
                  className="mb-6 flex flex-col gap-2"
                >
                  <Radio value="online">
                    <span className="flex items-center gap-2">
                      {icons.CreditCard}
                      <span className={`flex ${isMobile ? 'flex-col' : 'gap-1'}`}>
                        <span>Pay online</span>
                        <span className={`text-gray-500 ${isMobile ? 'text-sm' : 'text-sm'}`}>(credit card, QR code, Apple Pay, Google Pay)</span>
                      </span>
                    </span>
                  </Radio>
                  <Radio value="manager">
                    <span className="flex items-center gap-2">{icons.TeamManager} Pay in cash through my team manager</span>
                  </Radio>
                </Radio.Group>
                <Button
                  type="primary"
                  block
                  disabled={!agree}
                  loading={loading}
                  onClick={() => onAccept(payOption)}
                >
                  {payOption === 'manager' ? 'Confirm my choice' : 'Pay'}
                </Button>
              </>
            )
          ) : (
            <>
              <PlayerRegTermsDisplay
                terms={enabledTerms}
                checked={termsChecked}
                onChange={(idx, checked) => {
                  setTermsChecked(prev => {
                    const arr = [...prev];
                    arr[idx] = checked;
                    return arr;
                  });
                }}
              />
              <Button
                type="primary"
                className="mt-4"
                block
                loading={loading}
                onClick={() => onAccept()}
                disabled={!allChecked}
              >
                Accept
              </Button>
            </>
          )}
        </div>
      </>
    )
  }

  return (
    isMobile ? (
      <SteppedDrawer
        placement="bottom"
        onClose={onCancel}
        open={open}
        step={step}
        height="auto"
        style={{ maxHeight: '100vh' }}
        bodyStyle={{
          padding: '0 24px 24px',
          maxHeight: 'calc(100vh - 64px)',
          overflow: 'auto'
        }}
        footer={null}
        title={modal.needsPayment ? 'Accept and Pay' : 'Accept'}
      >
        <Contents />
      </SteppedDrawer>
    ) : (
      <Modal
        open={open}
        onCancel={onCancel}
        footer={null}
        title={modal.needsPayment ? 'Accept and Pay' : 'Accept'}
        width={800}
        style={{ maxWidth: '100vw' }}
        className="max-w-full"
        bodyStyle={{ padding: '0 24px 24px' , maxHeight: '75vh', overflow: 'scroll' }}
      >
        <Contents />
      </Modal>
    )
  );
};

export default SeasonPlayerRegistrationModal; 